import { CommonModule } from '@angular/common';
import { NgModule, LOCALE_ID } from '@angular/core';
import { CoreModule } from 'dbweb-core';
import { ConfirmDialogModule } from './components/confirm-dialog/confirm-dialog.module';
import { HomeModule } from './home/home.module';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { BillControllerService } from 'dbweb-core';
import { CTRL_ELEMENT, CTRL_TASK, CTRL_ROLE, CTRL_USER, CTRL_NOTICE } from './const';

import { registerLocaleData } from '@angular/common';
import localeZh from '@angular/common/locales/zh-Hans';
import { PromptDialogModule } from './components/prompt-dialog/prompt-dialog.module';
registerLocaleData(localeZh);
@NgModule({
	imports: [CommonModule, CoreModule, HomeModule, PageNotFoundModule, ConfirmDialogModule, PromptDialogModule],
	providers: [{ provide: LOCALE_ID, useValue: 'zh-Hans' }]
})
export class DBWebCommonModule {
	constructor(ctrl: BillControllerService) {
		const ctrlNameList = [CTRL_ELEMENT, CTRL_TASK, CTRL_ROLE, CTRL_USER, CTRL_NOTICE];
		ctrlNameList.forEach(ctrlName => {
			ctrl.register(ctrlName);
		});
	}
}
